// mm-atc-id-autofill.js  —— 通用：首屏写入 + 切换同步 + 提交兜底（零打扰）
if (!window.__mm_atc_id_autofill__) {
  window.__mm_atc_id_autofill__ = true;

  // 从页面/表单尽可能多的来源解析出应使用的 variantId
  const readVariantId = (form) => {
    // 1) URL 参数 ?variant=xxx（产品页常见）
    const urlId = new URL(location.href).searchParams.get('variant');
    if (urlId) return Number(urlId) || null;

    // 2) 表单里本来就有 <select name="id"> 或 <input type="radio" name="id">
    const sel = form.querySelector('select[name="id"]');
    if (sel && sel.value) return Number(sel.value) || null;
    const checkedRadio = form.querySelector('input[type="radio"][name="id"]:checked');
    if (checkedRadio && checkedRadio.value) return Number(checkedRadio.value) || null;

    // 3) 按钮或容器上的 data-variant-id（很多 quick-add 用这个）
    const byData = form.querySelector('[data-variant-id]')?.getAttribute('data-variant-id');
    if (byData) return Number(byData) || null;

    // 4) 主题全局商品 JSON（尽力而为：已选 > 可售首个 > 第一个）
    const p = (window.Shopify && Shopify.product) || (window.meta && meta.product) || null;
    if (p?.variants?.length) {
      const selected = p.variants.find(v => v.selected);
      if (selected?.id) return Number(selected.id);
      const available = p.variants.find(v => v.available);
      if (available?.id) return Number(available.id);
      return Number(p.variants[0].id);
    }

    return null;
  };

  // 往 form 写入隐藏 id（仅在缺或为空时写，不覆盖主题已有值）
  const ensureIdOnForm = (form) => {
    if (!form || form.getAttribute('action') !== '/cart/add') return;
    let idInput = form.querySelector('input[name="id"]');
    if (!idInput) {
      idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      form.appendChild(idInput);
    }
    if (!idInput.value) {
      const vid = readVariantId(form);
      if (vid) idInput.value = vid;
    }
  };

  const patchAllForms = () => {
    document.querySelectorAll('form[action="/cart/add"]').forEach(ensureIdOnForm);
  };

  // 1) 首屏尽快补一次
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchAllForms, { once: true });
  } else {
    patchAllForms();
  }

  // 2) 监听选项变化（颜色/尺码/数量切换时再同步一次）
  document.addEventListener('change', (e) => {
    const form = e.target.closest('form[action="/cart/add"]');
    if (form) ensureIdOnForm(form);
  });

  // 3) DOM 异步渲染（抽屉/弹窗/Quick Add）出现新表单时自动补
  new MutationObserver(patchAllForms).observe(document.body, { childList: true, subtree: true });

  // 4) 提交兜底：若仍为空，自动填上并无感重提（不弹窗、不打断）
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form?.getAttribute('action') !== '/cart/add') return;
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput || !String(idInput.value).trim()) {
      e.preventDefault();
      ensureIdOnForm(form);
      const fixed = form.querySelector('input[name="id"]')?.value;
      if (fixed) setTimeout(() => form.submit(), 0); // 静默重提
      // 如果仍然拿不到，通常是主题未暴露商品数据；此时也不打扰用户，仅在控制台留痕
      else console.warn('[ATC autofill] Unable to resolve variant id.');
    }
  }, true);
}
